import { PartnerUserEditPage } from "@/features/rso/pages/partner-user/PartnerUserEdit";

const MatchUserEdit = () => {
  return <PartnerUserEditPage />;
};

export default MatchUserEdit;
